import "esbuild-css-modules-plugin-ns-css:src/artifacts/dashboard/styles/form.module.css";

export default {
  "error": "form-module__error_VmCf3a__010",
  "field": "form-module__field_VmCf3a__010",
  "form": "form-module__form_VmCf3a__010",
  "input": "form-module__input_VmCf3a__010"
};
      